<template>
    <div class="product-form__unit-info">
        <div class="product-form__unit-inputs">
            <h2>Describe the unit</h2>
            <product-form-input-row>
                <div slot="inputs" class="unit-inputs">
                    <unit-inputs
                        v-bind.sync="productData"
                        @update:unitType="$emit('update:unitType', $event)"
                        @update:unitOfMeasurement="
                            $emit('update:unitOfMeasurement', $event)
                        "
                        @update:unitSize="$emit('update:unitSize', $event)"
                    ></unit-inputs>
                </div>
                <template slot="description">
                    The quantity and UOM is really important for the recipe
                    calculator later on. Eg. Bottle of 330ml, Can of 500g.
                </template>
            </product-form-input-row>
        </div>

        <div class="product-form__unit-cost">
            <h2>Cost per unit</h2>
            <product-form-input-row>
                <template slot="inputs">
                    <el-input-number
                        v-model="productData.unitPrice"
                        :controls="false"
                        :precision="2"
                        placeholder="$0.00"
                    ></el-input-number>
                </template>
                <template slot="description">
                    The quantity and UOM is really important for the recipe
                    calculator later on. Eg. Bottle of 330ml, Can of 500g.
                </template>
            </product-form-input-row>
        </div>
    </div>
</template>

<script>
import UnitDropdownOptionsMixin from "Mixins/UnitDropdownOptionsMixin";

import UnitInputs from "Components/UnitInputs";

import ProductFormInputRow from "./ProductFormInputRow";

export default {
    components: {
        UnitInputs,
        ProductFormInputRow,
    },
    mixins: [UnitDropdownOptionsMixin],
    props: {
        productData: Object,
    },
    data: () => ({}),
};
</script>

<style scoped lang="scss">
.product-form__unit-info {
    /deep/ input.el-input__inner {
        text-align: left;
    }
}

/deep/ .unit-inputs {
    display: flex;

    div {
        flex: 1;
        margin-right: 10px;
    }
}
</style>
